import * as React from "react";
import { Checkbox, Input } from "uxp/components";
import { Property, PropertyGroup, PropertyGroupTitle, PropertyTitle } from "../ui-props/common";
export interface IFieldTitleProps {
    label?: string;
    description?:string;
    required?:boolean;
}
export const FieldTitle : React.FunctionComponent<IFieldTitleProps> = (props) => {
    let {label,description,required} = props;
    if (!label && !description) {
        return null;
    }
    return <>
    {label && <div className='ui-field-label'>{ (required?'*':'')+props.label }</div>}
    {description && <div className='ui-field-description'>{props.description}</div>}
    </>;
}

export interface IFieldPropertyProps {
    uiProps: any;
    onChange:(obj:any) => void;
}
export const FieldProperty:React.FunctionComponent<IFieldPropertyProps> = (props)=>{
    let fp:IFieldTitleProps = props.uiProps?.fieldLabel || {};
    return <PropertyGroup>
        <PropertyGroupTitle>Label</PropertyGroupTitle>
        <Property>
				<PropertyTitle>Label</PropertyTitle>
				<Input
					value={fp.label || ''}
					onChange={s => props.onChange(Object.assign({}, props.uiProps,{fieldLabel:{ ...fp,...{label:s} }}))}
					className="widget-designer-input"
				/>
			</Property>
            <Property>
				<PropertyTitle>Description</PropertyTitle>
				<Input
					value={fp.description || ''}
					onChange={s => props.onChange(Object.assign({}, props.uiProps,{fieldLabel:{ ...fp,...{description:s} }}))}
					className="widget-designer-input"
				/>
			</Property>
            <Property>
				<PropertyTitle>Required Field</PropertyTitle>
				<Checkbox
					checked={!!fp.required}
                    label={'It is mandatory to fill this field'}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, {fieldLabel:{ ...fp,...{required:s} }}))}
					className="widget-designer-input"
				/>
			</Property>
    </PropertyGroup>;
};